import React, { useState } from 'react';
import TBodyRow from './TBodyRow';

interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: any;
  handleSumbit: any;
  uploadImageFile: any;
  setIsOpenPopup: any;
  setPartIdx: any;
}

const TBody = ({
  moduleData,
  handleSumbit,
  isView,
  handelDeleteRows,
  uploadImageFile,
  setIsOpenPopup,
  setPartIdx,
}: IProps) => {
  // const [render, setRender] = useState(false);
  return (
    <>
      <tbody>
        {moduleData &&
          moduleData.processes.map((process: any, index: number) => (
            <React.Fragment key={index + 1 + 'process'}>
              <TBodyRow
                {...{
                  moduleData,
                  process,
                  index,
                  isView,
                  handelDeleteRows,
                  handleSumbit,
                  uploadImageFile,
                  setIsOpenPopup,
                  setPartIdx,
                }}
              />
            </React.Fragment>
          ))}
      </tbody>
    </>
  );
};

export default TBody;
